namespace TabAurous.OMS {
    export interface DepartmentMasterForm {
        DeptCode: Serenity.StringEditor;
        DeptName: Serenity.StringEditor;
        DepartmentTypeId: Serenity.LookupEditor;
        ParentDeptId: Serenity.LookupEditor;
        ItemTypeId: Serenity.LookupEditor;
        CompanyId: Serenity.LookupEditor;
        Narration: Serenity.StringEditor;
        ProcessDetails: Serenity.LookupEditor;
    }

    export class DepartmentMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.DepartmentMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DepartmentMasterForm.init)  {
                DepartmentMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(DepartmentMasterForm, [
                    'DeptCode', w0,
                    'DeptName', w0,
                    'DepartmentTypeId', w1,
                    'ParentDeptId', w1,
                    'ItemTypeId', w1,
                    'CompanyId', w1,
                    'Narration', w0,
                    'ProcessDetails', w1
                ]);
            }
        }
    }
}
